import * as React from "react";
import { Route } from "react-router";

export class LandingRoute extends Route<any> {
	public render() {
		return( 
            <Route {...this.props} />
        )
	}
}